// src/pages/Cookies.jsx

import React from "react";

export default function Cookies() {
  return (
    <main className="min-h-screen bg-[#F7F4EA] px-4 py-8 text-[#1E2A38]">
      <div className="mx-auto max-w-3xl rounded-2xl bg-white p-6 shadow-md md:p-10">
        <h1 className="mb-2 text-3xl font-bold">TeamKitty Cookie Policy</h1>

        <p className="mb-6 text-sm text-slate-500">
          <strong>Effective Date:</strong>{" "}
          {new Date().toISOString().slice(0, 10)}
        </p>

        <p className="mb-4">
          TeamKitty uses cookies and similar technologies to provide core
          platform functionality, maintain security and improve the user
          experience.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          1. What Are Cookies?
        </h2>

        <p className="mb-4">
          Cookies are small files stored on your device that help websites and
          applications function correctly.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          2. How TeamKitty Uses Cookies
        </h2>

        <p className="mb-4">
          TeamKitty may use cookies or similar technologies for:
        </p>

        <ul className="mb-4 ml-6 list-disc">
          <li>secure login and authentication</li>
          <li>maintaining user sessions</li>
          <li>payment processing and fraud prevention</li>
          <li>security and platform protection</li>
          <li>remembering basic preferences</li>
        </ul>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          3. Third-Party Services
        </h2>

        <p className="mb-4">
          Third-party providers such as Stripe, Amazon Web Services and Amazon
          Cognito may also use cookies or related technologies as part of their
          services.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          4. Advertising Cookies
        </h2>

        <p className="mb-4">
          TeamKitty does not currently use advertising or remarketing tracking
          cookies.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          5. Managing Cookies
        </h2>

        <p className="mb-4">
          Most browsers allow you to control or disable cookies through browser
          settings. Disabling essential cookies may impact platform
          functionality.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          6. Changes to this Policy
        </h2>

        <p className="mb-4">
          We may update this Cookie Policy from time to time.
        </p>

        <p className="mt-8 text-sm text-slate-500">
          Contact:{" "}
          <a
            href="mailto:contact@teamkitty.io"
            className="text-[#0F766E] underline"
          >
            contact@teamkitty.io
          </a>
        </p>
      </div>
    </main>
  );
}